module.exports = __webpack_public_path__ + "img/md-pwd.ea3672e0.svg";